import { api } from '@/lib/api';

const unwrap = (p) => p.then((r) => r.data);

/**
 * Avviso di vetrina (banner scorrevole) per stakeholder.
 * - get/save: CRM dello stakeholder loggato.
 * - publicBanner: avviso attivo per una vetrina pubblica (per owner_id).
 */
export const bannerService = {
  get: () => unwrap(api.get('/stakeholder/banner')),
  save: (body) => unwrap(api.put('/stakeholder/banner', body)),
  publicBanner: (ownerId) => unwrap(api.get(`/public/banner/${ownerId}`)),
};

export default bannerService;
